// extracted by mini-css-extract-plugin
module.exports = {"NAME_HORIZONTAL_CARD":"HorizontalCard","TYPE_HORIZONTAL_CARD":"Section"};